var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "flex flex-row gap-4 items-top customContainer pt-5 sm:pt-2 pb-2 justify-flex-start items-flex-start",
    },
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-col items-top gap-4 sm:flex-row" },
          [
            _c("FormGroup", {
              key: "item1",
              attrs: {
                title: "",
                type: "search",
                iconStyle: "customIcon",
                inputClass: "customFormInput fullwidthform",
                placeholder: "Search by Client name",
                debounceTime: 500,
              },
              model: {
                value: _vm.title,
                callback: function ($$v) {
                  _vm.title = $$v
                },
                expression: "title",
              },
            }),
            _c(
              "FormGroup",
              { key: "item8", staticClass: "mb-2" },
              [
                _c("FormDatepicker", {
                  attrs: {
                    iconStyle: "customIcon",
                    inputClass: "customFormInput",
                    calendarClass:
                      "right-0 sm:right-0 sm:left-auto left-0 sm:left-auto",
                    customInputClass: "rounded-lg text-storm-gray text-sm h-1",
                    label: "",
                    placeholder: "Date created",
                  },
                  model: {
                    value: _vm.createdAt,
                    callback: function ($$v) {
                      _vm.createdAt = $$v
                    },
                    expression: "createdAt",
                  },
                }),
              ],
              1
            ),
            _c("FormGroup", {
              key: "item1",
              attrs: {
                title: "",
                type: "search",
                iconStyle: "customIcon",
                inputClass: "customFormInput fullwidthform",
                placeholder: "Search by address",
                debounceTime: 500,
              },
              model: {
                value: _vm.location,
                callback: function ($$v) {
                  _vm.location = $$v
                },
                expression: "location",
              },
            }),
            !_vm.hideManagersFilter
              ? _c(
                  "FormGroup",
                  { key: "item6" },
                  [
                    _c("ManagersMultiselect", {
                      attrs: {
                        value: _vm.filters.managers,
                        getParentcontainerStyle: "customWidthMax smallHeight",
                        multiple: "",
                        additionalConditions: _vm.managersMultiselectConditions,
                        debounceTime: 1000,
                      },
                      on: {
                        input: (chosenManagers) =>
                          (_vm.managersIds = chosenManagers),
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "mx-4" },
          [
            _c("UiButtonMessage", {
              attrs: {
                buttonClass: "customAdd",
                buttonText: "Reset",
                textClass: "customText customOnlyText",
              },
              on: { click: _vm.handleReset },
            }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }